<template>
	<div class="st-main-content">
		<div class="account-search-box">
			<div class="query-setting-box">
				<div class="query-setting-box-left">
					<!-- <div class="order-query-form-box">
						<label for="start-date">用户id：</label>
						<span class="order-query-form-input"><input type="text" v-model="orderForm.roleId"
								name="start-date"></span>
					</div>
					<div class="order-query-form-box">
						<label for="start-date">姓名：</label>
						<span class="order-query-form-input"><input type="text" v-model="orderForm.username"
								name="start-date"></span>
					</div>
					<div class="order-query-form-box">
						<label for="start-date">角色名称：</label>
						<span class="order-query-form-input"><input type="text" v-model="orderForm.loginAccount"
								name="start-date"></span>
					</div> -->
					
					<el-form :inline="true" :model="orderForm" class="demo-form-inline">
						<el-form-item label="公司名称:">
							<el-input v-model="orderForm.companyName" placeholder="请输入公司名称" clearable style="margin-right: 12px"></el-input>
						</el-form-item>
						<el-form-item label="临近30天到期:">
							<el-select v-model="orderForm.defaultExpire" placeholder="请选择" clearable style="margin-right: 12px">
								<el-option label="否" value="false"></el-option>
								<el-option label="是" value="true"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="近N天开单客户:">
							<el-input v-model="orderForm.recentlyTime" placeholder="" clearable style="margin-right: 12px"></el-input>
						</el-form-item>
						<el-form-item>
							<el-button type="warning" size="small" color="#ff5b3e" @click="searchList(true)">查询</el-button>
						</el-form-item>
						<!-- <div class="order-query-form-box-right"> -->
							<!-- <span class="order-query-form-submit stPointer" @click="searchList(true)">查询</span> -->
						<!-- </div> -->
					</el-form>
				</div>
			</div>
		</div>
		<div class="data-table-box">
			
			<common-table
				ref="CommonTableRef"
				:tableColumns="tableColumns"
				:data="dataList"
				:showPage="togglePage"
				:loading="loading"
				
				:pageConfig="pageConfig"
				:bottomHandleArr="bottomHandleArr"
				@selectionChange="selectionChange"
				@currentChange="currentChange"
				@sizeChange="sizeChange"
			>
				<template slot="state" slot-scope="scope">
					<span>{{ scope.row.state }}</span>
				</template>
				<template slot="vas" slot-scope="scope">
					<span>{{ scope.row.vas }}</span>
				</template>
				<template slot="contactSubject" slot-scope="scope">
                    <span>{{scope.row.contactSubject}}</span>
                </template>

				<template slot="state" slot-scope="scope">
					<span>{{scope.row.state?'是':'否'}}</span>
				</template>
			</common-table>
			
		</div>
		<st-dialog :title="dialogTitle" :toggleStDialog="toggleStDialog" @closeDialog="closeDialogForm" 
			@saveDialog="saveDialogForm">
			<div class="st-dialog-content" style="width: 850px;">
				<ul class="st-dialog-form clearfix">
					<li>
						<div class="st-dialog-item-title">公司名称：</div>
						<div class="st-dialog-item-input"><input type="text" v-model="editData.name"></div>
					</li>
					<li>
						<div class="st-dialog-item-title">联系人：</div>
						<div class="st-dialog-item-input"><input type="text" v-model="editData.contactSubject"></div>
					</li>
					<li>
						<div class="st-dialog-item-title">联系手机号：</div>
						<div class="st-dialog-item-input"><input type="text" v-model="editData.contactPhone"></div>
					</li>
					<li>
						<div class="st-dialog-item-title">密码录入：</div>
						<div class="st-dialog-item-input" style="display:flex;position: relative;"><input :type="pswText" v-model="editData.logisticsUser.password">
							<i class="el-icon-view" @click="showPwd" style="position: absolute;top: 8px;right: 10px"></i>
						</div>
					</li>
					<li>
						<div class="st-dialog-item-title">登录账号：</div>
						<div class="st-dialog-item-input"><input type="number"  v-model="editData.logisticsUser.username"></div>
					</li>
				</ul>

				<!-- <ul class="st-dialog-form clearfix">
					<li>
						<div class="st-dialog-item-title">加盟公司：</div>
						<div class="st-dialog-item-input"><input type="text" v-model="editData.contactSubject"></div>
					</li>
					<li>
						<div class="st-dialog-item-title">加盟公司手机号：</div>
						<div class="st-dialog-item-input"><input type="text" v-model="editData.contactPhone"></div>
					</li>
					<li>
						<div class="st-dialog-item-title">账户类型：</div>
						<div class="st-dialog-item-input">
							<el-select v-model="editData.genre" placeholder="请选择" size="small">
								<el-option v-for="item in options3" :key="item.value" :label="item.label"
									:value="item.value">
								</el-option>
							</el-select>
						</div>
					</li>
					<li style="width: 200px;">
						<div class="st-dialog-item-title">角色类型：</div>
						<div class="st-dialog-item-input">
							<el-select v-model="editData.roleId" 
							placeholder="请选择" 
							multiple
    						collapse-tags
							size="small">
								<el-option v-for="item in roleTypeList" 
								:key="item.id" 
								:label="item.name"
								:value="item.id">
								</el-option>
							</el-select>
						</div>
					</li>
				</ul> -->

				<!-- <ul class="st-dialog-form clearfix">
						<li>
							<div class="st-dialog-item-title">付款方式：</div>
							<div class="st-dialog-item-input">
								<el-select v-model="editData.waybillPaymentType" placeholder="请选择" size="small">
									<el-option v-for="item in paymentTypeList" :key="item.value" :label="item.label"
										:value="item.value">
									</el-option>
								</el-select>
							</div>
						</li>
					</ul>
 -->
				<ul class="st-dialog-form clearfix">
					<li style="width: 250px;">
						<div class="st-dialog-item-title">省/市/区</div>
						<div class="st-dialog-item-input">
							<el-cascader class="ssq" size="small" :options="options" v-model="selectedOptions"
								@change="handleChange"
							>
							</el-cascader>
						</div>
					</li>
					<li style="width: 250px;">
						<div class="st-dialog-item-title">详细地址：</div>
						<div class="st-dialog-item-input">
							<!-- <input type="text" v-model="editData.shortAddress"> -->
							<el-select class="ssq" v-model="editData.shortAddress" filterable remote :remote-method="getNearAddress"
							:loading="loading" placeholder="请输入详细地址" size="small" @change="shortAddressChange">
								<el-option
									v-for="item in nearAddressArr"
									:key="item.title"
									:label="item.title"
									:value="{value:item.title,location:item.location}">
								</el-option>
							</el-select>
						</div>
					</li>
				</ul>
			</div>
		</st-dialog>
		<el-dialog title="短信服务信息" :visible.sync="dialogVisible" width="30%" label-position="right" :before-close="handleClose">
			<el-form :model="form">
				<el-form-item label="账号" label-width="100px">
					<el-input v-model="form.field1" placeholder="请输入账号" clearable style="width: 70%"></el-input>
				</el-form-item>
				<el-form-item label="密码" label-width="100px">
					<el-input v-model="form.field2" placeholder="请输入密码" clearable style="width: 70%"></el-input>
				</el-form-item>
				<el-form-item label="短信签名" label-width="100px">
					<el-input v-model="form.field3" placeholder="请输入公司" clearable style="width: 70%"></el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer" style="text-align: center;margin-top: 12px;">
				<el-button @click="handleClose">取 消</el-button>
				<el-button type="primary" @click="confirm">确认并开通</el-button>
			</div>
    	</el-dialog>
		<!-- 更改续费信息dialog -->
		<el-dialog title="更改续费信息" :visible.sync="isShowfreeDialog" center>
			<div class="freeTime_wrap">
				<span>到期时间</span>
				 <el-date-picker
					v-model="pickerTime"
					type="date"
					value-format="timestamp"
					placeholder="选择日期">
				</el-date-picker>
					<span>续费金额</span>
				<el-input class="width_200px" v-model="freeValue" placeholder="请输入内容"></el-input>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button type="primary" @click="isShowfreeDialog = false">取 消</el-button>
				<el-button type="success" @click="freeConfrimBtnClick">确 定</el-button>
			</div>
		</el-dialog>

	</div>
</template>
<script>
	import stDialog from '../../components/StDialog'
	import { cityJson, CodeToText } from '@/assets/common/city.js'
	import { geoplace2, geoplace } from '@/utils/mapUtil.js'
	
	export default {
		name: 'AccountManage',
		props: [],
		components: { stDialog },
		data() {
			return {
				freeId:'',
				freeValue:'',
				pickerTime:'',
				isShowfreeDialog: false,
				dialogVisible: false,
				form: {},
				rowDataIndex: "",
				rowDataState: false,
				tableColumns:[
					{
						type: 'selection',
						fixed: 'left',
					},{
						key: '',
						title: '操作',
						width: 100,
						operate:true,
						setBtns:(row,index)=>{
							return [
								// {
								// 	label:'短信服务',
								// 	handler: (row,index) => this.messageService(row),
								// }
								// {
								// 	label:'编辑',
								// 	handler: (row,index) => this.editUser(row)
								// }
							]
						}
					},
					{
						key: 'state',
						title: '是否启用',
						width: 140,
						align: "center",
						render: (h, params) => {
							return h('el-switch', {
								props: {
									size: 'large',
									value: params.row.state ? true : false
								},
								// scopedSlots: {
								// 	open: () => h('span', "开启"),
								// 	close: () => h('span', "关闭")
								// },
								on: {
									"change": (value) => {
										this.toggleStatusForStart(params,value);
									}
								}
							})
						}
					},
					{
						key: 'vas',
						title: '是否开通短信服务',
						width: 140,
						align: "center",
						render: (h, params) => {
							return h('el-switch', {
								props: {
									size: 'large',
									value: params.row.vas ? true : false
								},
								// scopedSlots: {
								// 	open: () => h('span', "开启"),
								// 	close: () => h('span', "关闭")
								// },
								on: {
									"change": (value) => {
										this.toggleStatus(params.index, value);
									}
								}
							})
						}
					},
					{
						key:'name',
						title: '公司名称',
					},
					{
						key: 'contactPhone',
						title: '手机号',
					},{
						key: 'contactSubject',
						title: '联系人',
					},{
						slotName: 'state',
						slot:true,
						title: '是否有效',
					},
					{
						key: 'expiryTime',
						title: '到期时间',
					},
					{
						key: 'createTime',
						title: '开通时间',
					},
					{
						key: 'paymentAmount',
						title: '续费金额',
					},
					{
						key: 'createTimeEarly',
						title: '最近开单日期',
					},
					// {
					// 	key: 'contactSubject',
					// 	title: '用户名',
					// },
					{
						key: 'provinceName',
						title: '省',
					},{
						key: 'cityName',
						title: '市',
					},{
						key: 'areaName',
						title: '区',
					},{
						key: 'shortAddress',
						title: '详细地址',
					}
				],
				loading: false,
				pageConfig: {
					total: 0,
					pageSize: 100,
					currentPage: 1,
					layout: "total, sizes",
				},
				bottomHandleArr: [
					// {
					// 	label: '删除账号',
					// 	handler: () => this.deleteUser()
					// },
					{
						label: '更改续费信息',
						type: 'success',
						handler: () => this.changeFreeInfo()
					},
					{
						label: '新增账号',
						type: 'success',
						handler: () => this.addUser()
					},
				],


				nearAddressArr: [],
				loading: false,
				options: cityJson,
				selectedOptions: [],
				options2: [{
					value: '1',
					label: '是'
				}, {
					value: '2',
					label: '否'
				}],
				options3: [{
					value: 'SYSTEM',
					label: '系统用户'
				}, {
					value: 'FRANCHISE',
					label: '加盟公司'
				}],
				paymentTypeList: [{
					value: 0,
					label: '寄付'
				}, {
					value: 1,
					label: '到付'
				}, {
					value: 2,
					label: '月结'
				}],
				roleTypeList: [
					{
						name: '超级管理员',
						id: 0
					},
					{
						name: '加盟公司',
						id: 1
					},
					{
						name: '管理员',
						id: 2
					},
				],
				value: '',
				value2: '',
				userId: null,
				currentEditData:{},
				editData: {
					genre: '系统用户',
					state:'',
					logisticsUser:{
						password:'',
						username:''
					}
				},
				normalCheck: {
					name: '公司名必填',
					contactSubject: '用户名必填',
					contactPhone: '手机号必填',
					// password: '登录密码必填',
					// username: '用户名必填',
			
				},
				franshiseCheck: {
					provinceName: '省市区必填',
					shortAddress: '详细地址必填',
					contactPhone: '联系方式必填',
					contactSubject: '联系人或公司必填'
				},
				dataList: [],
				selectedList: [],
				orderForm: {
					loginAccount: null, //	登录账号	string	
					roleId: null, //	角色id	array<number>	
					username: null, //用户名
					// defaultExpire: 'false',
					defaultExpire: null,
					recentlyTime: ''
				},
				togglePage: false, //是否显示分页
				toggleStDialog: false,// 弹窗，
				dialogTitle: '新增角色2',
				pswText: 'password'
			}
		},
		created() {

		},
		methods: {
			showPwd(){
				this.pswText = this.pswText === 'password' ? 'text' : 'password'
			},
			sizeChange(size) {
				this.pageConfig.currentPage = 1
				this.pageConfig.pageSize = size
				this.searchList()
			},

			currentChange(currentPage) {
				this.pageConfig.currentPage = currentPage
				this.searchList()
			},
			shortAddressChange({value, location}) {
				this.editData.longitude = location.lng
				this.editData.latitude = location.lat
				this.editData.shortAddress = value
			},

			getNearAddress(e) {
				if (this.selectedOptions.length == 0) {
					return this.$toast.stMessage('请先选择省市区', 'warning')
				}
				this.loading = true;
				geoplace2(this, e, CodeToText[this.selectedOptions[1]]).then(res => {
					console.log('结果', res)
					if (res.message === "Success") {
						this.loading = false
						this.nearAddressArr = res.data
					} else {
						this.loading = false
						this.$toast.stMessage(res.message)
					}
				})
			},
			
			deleteUser() {
				if (this.selectedList.length == 0) {
					return this.$toast.stMessage('请选择需要删除的用户', false)
				}

				if (this.selectedList.length != 1) {
					return this.$toast.stMessage('请勿选择多个用户', false)
				}

				this.$confirm('是否确认删除用户?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
				}).then(() => {
					this.$server.system.deleteUser(this.selectedList[0].id, (res) => {
						this.$message({
							type: 'success',
							message: '删除成功!'
						});
						this.searchList()
					})
				})
			},

			addUser() {
				this.editData = {
					genre: 'SYSTEM',
					state:1,
					logisticsUser:{
						password:'',
						username:''
					},
					  logisticsSite:{
					    }
				}
				console.log(this.editData)
				this.dialogTitle = '新增账号'
				this.toggleStDialog = true
			},
			changeFreeInfo() {
				if(this.selectedList.length  !== 1) return this.$message.warning('请选择一条数据')
				const {id,paymentAmount,expiryTime} = this.selectedList[0]
				this.pickerTime  = new Date(expiryTime).getTime()
				this.freeValue = paymentAmount
				this.freeId = id
				this.isShowfreeDialog = true

			},
			freeConfrimBtnClick() {
				const data = {
					id: this.freeId,
					expiryTime: this.pickerTime,
					paymentAmount: this.freeValue
				}
				this.$server.system.changeFreeInfoData(data, (res) => {
					this.loading=false;
					if (res.code == 0) {
						this.searchList(true)
						this.isShowfreeDialog = false
					}
				})
				
			},

			resetEditData() {
				this.editData = {
					genre: 'SYSTEM',
					state:1,
					logisticsUser:{
						password:'',
						username:''
					},
					logisticsSite:{
					  }
				}
				this.selectedOptions = []
			},

			handleChange(value) {
				console.log(value)
				// 省市区选择
				const [provinceName, cityName, areaName] = [CodeToText[value[0]], CodeToText[value[1]], CodeToText[value[2]]]
				this.editData.provinceName = provinceName
				this.editData.cityName = cityName
				this.editData.areaName = areaName
				this.editData.provinceCode = value[0]
				this.editData.cityCode = value[1]
				this.editData.areaCode = value[2]
				this.editData.fullAddress = provinceName + cityName + areaName
			},

			selectionChange(val) {
				this.selectedList = val;
				console.log(this.selectedList)
			},

			searchList(flag) {
				let pages = {};
				pages.size = this.pageConfig.pageSize;
				pages.current = this.pageConfig.currentPage;
				if(flag) pages.current = 1;
				let orderForm = {
					companyName: this.orderForm.companyName,
					recentlyTime: this.orderForm.recentlyTime,
					expire: this.orderForm.defaultExpire
					// expire: JSON.parse(this.orderForm.defaultExpire)
				}
				Object.assign(orderForm, pages)
				this.loading = true;
				this.getData(orderForm)
			},
			
			getRoleList() {
				this.$server.role.getRole({
					current: 1,
					size: 999
				}, res => {
					console.log(res)
					this.roleTypeList = res.data.records
				})
			},

			async getData(data) {
				console.log("查询传参",data)
				// return;
				try {
					// 使用 Promise 包装回调函数，添加超时控制
					const result = await new Promise((resolve, reject) => {
						let timeoutId = setTimeout(() => {
							reject(new Error("请求超时，请检查网络连接或稍后重试"));
						}, 30000); // 10秒超时
						
						this.$server.system.LogisticsUserPage(data, (res) => {
							clearTimeout(timeoutId);
							if (res.code == 0) {
								this.loading = false
								res.data.records.map(item => {
									item.expiryTime = item.expiryTime ? 
									this.timeConversion(item.expiryTime, true) : ''
									item.createTimeEarly = item.createTimeEarly ? 
									this.timeConversion(item.createTimeEarly, false) : ''
									item.createTime = item.createTime ? 
									this.timeConversion(item.createTime, false) : ''
								})
								this.dataList = res.data.records;
								this.pageConfig.total = res.data.total || res.data.records.length;
								this.pageConfig.currentPage = res.data.current;
								this.togglePage = res.data.total > 0;
								resolve(res);
							} else {
								reject(new Error(res.message || "查询失败"));
							}
						}, (error) => {
							clearTimeout(timeoutId);
							reject(error);
						})
					})
				} catch (error) {
					this.loading = false
					console.error("查询error", error);
					if (error.message?.includes("timeout")) {
						this.$message.error(error.message)
					} else {
						this.$message.error("网络请求失败：" + (error.message || "未知错误"));
					}
				} finally {
					this.loading = false
				}
			},

			timeConversion(Time, isTime) {
				var date = new Date(Time) //时间戳为10位需*1000，时间戳为13位的话不需乘1000
				var Y = date.getFullYear() + '-'
				let M =
					date.getMonth() + 1 < 10
					? '0' + (date.getMonth() + 1) + '-'
					: date.getMonth() + 1 + '-'
				let D =
					date.getDate() < 10 ? '0' + date.getDate() + '' : date.getDate() + ''
				let h =
					date.getHours() < 10
					? '0' + date.getHours() + ':'
					: date.getHours() + ':'
				let m =
					date.getMinutes() < 10
					? '0' + date.getMinutes() + ':'
					: date.getMinutes() + ':'
				let s =
					date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
				if(isTime) {
					return Y + M + D + ' ' + h + m + s
				} else {
					return Y + M + D
				}
			},

			getRoldId(id) {
				return new Promise((resolve, reject) => {
					this.$server.role.getUser(id, res => {
						const roleId = res.data.roleList.map(item => {
							return item.id
						})
						resolve(roleId)
					})
				})
			},

			async editUser(row) {
				this.dialogTitle = '编辑账号'
				const roleId = await this.getRoldId(row.id)
				this.$nextTick(() => {
					this.editData = JSON.parse(JSON.stringify(row))
					this.$set(this.editData,"roleId", roleId)
					this.selectedOptions = [row.provinceCode, row.cityCode, row.areaCode]
					this.toggleStDialog = true;
				})
				
			},

			// 短信服务
			messageService(row) {
				console.log("点击了短信服务", row)
			},
			toggleStatus(index, value) {
				console.log("点击了开关", index, value);
				this.rowDataIndex = index
				this.rowDataState = value
				if(value) {
					this.dialogVisible = true
					this.form = {}
				} else {
					this.$confirm('是否确认关闭短信服务?', '温馨提示', {
						confirmButtonText: '是',
						cancelButtonText: '否',
						type: 'warning'
					}).then(() => {
						let data = {
							companyId: this.dataList[this.rowDataIndex].id
						}
						this.$server.system.deleteMessageService(data, (res) => {
							console.log("取消成功返回的数据", res);
							if(res.code !== 0) return
							this.dataList[index].vas = value;
							this.$message({
								type: 'success',
								message: '取消短信服务成功!'
							})
						})
					})
					.catch(() => {
						this.$message({
							type: 'info',
							message: '已取消操作'
						})         
					})
				}
				// this.dataList[index].vas = value;
			},
toggleStatusForStart(item,bool) {
				console.log("toggleStatusForStart", item,bool);
			
					this.$confirm('是否确定此操作?', '温馨提示', {
						confirmButtonText: '是',
						cancelButtonText: '否',
						type: 'warning'
					}).then(() => {
						const data = {
							state:bool ? 1 : 0,
							id:item.row.id
						}
						console.log('这个是data',data)
						this.$server.system.isStartMessageService(data, (res) => {
							console.log("取消成功返回的数据", res);
							if(res.code !== 0) return
							this.dataList[item.index].state =bool;
							this.$message({
								type: 'success',
								message: '操作成功!'
							})
						})
					})
					.catch((err) => {
						// console.log('这个是err',err)
						this.$message({
							type: 'info',
							message: '已取消操作'
						})         
					})
				// this.dataList[index].vas = value;
			},
			//确认增值
			confirm() {
				let data = {
					...this.form,
					companyId: this.dataList[this.rowDataIndex].id
				}
				console.log("点击了确认", data, this.rowDataState);
				this.$server.system.addMessageService(data, (res) => {
					console.log("开通成功返回的数据", res);
					if(res.code !== 0) return
					this.dialogVisible = false
					this.dataList[this.rowDataIndex].vas = this.rowDataState 
					this.$message({
						type: 'success',
						message: '开通短信服务成功!'
					})
				})
			},
			handleClose(){
				this.dialogVisible = false
			},

			checkData() {
				for (let i in this.normalCheck) {
					if (!this.editData[i]) {
						this.$toast.stMessage(this.normalCheck[i], false)
						return false
					}
				}

				if (this.editData.genre == 'FRANCHISE') {
					for (let i in this.franshiseCheck) {
						if (!this.editData[i]) {
							this.$toast.stMessage(this.franshiseCheck[i], false)
							return false
						}
					}
				}

				return true
			},

			async saveDialogForm() {
				
				if (!this.checkData()) return
				let data = Object.assign({}, this.editData);
				// 测试
				// let data = {
				// 	name:"省钱运测试物流",
				// 	state:1,
				// 	contactPhone:"15302394457",
				// 	contactSubject:"cyx",
				// 	provinceCode: "440000",
				// 	provinceName:"广东省",
				// 	cityCode: "442000",
				// 	cityName:"中山市",
				// 	areaCode:"442013",
				// 	areaName:"古镇镇",
				// 	shortAddress:"华艺广场",
				// 	fullAddress:"广东省中山市古镇中兴大道南1号",
				// 	latitude:"22.602723",
				// 	longitude:"113.189382",
				// 	logisticsUser:{
				// 		username:"15302394457",
				// 		password:"e10adc3949ba59abbe56e057f20f883e"
				// 	},
				// 	"logisticsSite":{
				// 	}

				// }
				let sendMethod = 'editLogisticsUser'
		
			let newData=JSON.parse(JSON.stringify(data));
			newData.logisticsUser.password = this.$md5(this.editData.logisticsUser.password);
				if (!this.editData.id) {
					sendMethod = 'addLogisticsUser'
				}
				//保存设置
				this.$server.system[sendMethod](newData, res => {
					if (res.code == 0) {
						this.$toast.stMessage(`设置成功`, true)
						this.toggleStDialog = false;
						this.searchList()
					} else {
						this.$toast.stMessage(res.message, false)
					}
				})
			},
			closeDialogForm(){
				this.toggleStDialog=false;
			},
			changeStatus(row) {
				this.$server.system.switchUserState(row.id, res => {
					if (res.code == 0) {
						this.$toast.stMessage(`设置成功`, true)
					} else {
						this.$toast.stMessage(res.message, false)
						this.resetEditData()
						this.searchList()
					}
				})
			},
		},
		mounted() {
			this.getRoleList()
		}
	}

</script>


<style scoped>
	.st-main-content .el-input__icon {
		line-height: normal;
	}
	
	.st-main-content .ssq {
		width: 250px;
		height: 31px;
		line-height: normal;
	}
	
	.st-main-content .ssq .el-input__inner {
		width: 250px;
	}
	.require-desc {
		color: red;
	}

	.st-dialog-form {
		display: flex;
		justify-content: flex-start;
		width: 720px;
	}

	.st-dialog-form li {
		margin-right: 20px;
	}

	.query-setting-box-left {
		flex-grow: 0;
	}

	.account-manage {
		width: 100%;
		height: auto;
	}

	.setRole {
		display: inline-block;
		width: 95px;
		height: 32px;
		line-height: 32px;
		color: #32BB57;
		cursor: pointer;
		margin: 0;

	}

	.st-order-btns {
		display: flex;
		justify-content: space-around;
	}

	.st-order-btns span {
		width: 80px;
		height: 30px;
		line-height: 30px;
		text-align: center;
		color: #fff;
		border-radius: 2px;
		cursor: pointer;
		margin-left: 8px;
	}

	.stStgz {
		background-color: #FF5B3E;
	}

	.stMbgc {
		background-color: #32BB57;
	}

	/* 弹窗内 */
	/*  */
	.st-dialog-content {
		min-height: 200px;
		padding: 0 32px;
	}

	.st-dialog-form {
		display: flex;
		justify-content: flex-start;
		align-items: center;
	}

	.st-dialog-form li {
		width: 156px;
		padding: 13px 0;
	}

	.st-dialog-form li:nth-child(even) {
		float: right;
	}

	.st-dialog-form li:nth-child(odd) {
		float: left;
	}

	.st-dialog-form .st-dialog-item-title {
		height: 20px;
		line-height: 20px;
	}

	.st-dialog-form .st-dialog-item-title i {
		color: #FF5B3E;
	}

	.st-dialog-form .st-dialog-item-input input {
		width: 156px;
		height: 30px;
		text-indent: 8px;
		border-radius: 2px;
		border: 1px solid #DCDCDC;
		box-sizing: border-box;
	}

	.setConfig {
		cursor: pointer;
	}
 .width_30px {
    width: 30px;
  }
  .width_60px {
    width: 60px;
  }
  .width_120px {
    width: 120px;
  }
  .width_150px {
    width: 150px;
  }
  .width_200px {
    width: 200px;
  }
  .width_300px {
    width: 300px;
  }
  .width_400px {
    width: 400px;
  }
  .width_500px {
    width: 500px;
  }
  .freeTime_wrap {
	display: flex;
	justify-content: center;
	align-items: center;
	
  }
  .freeTime_wrap span {
		margin: 0 10px;
	}
	/* end */
</style>